import endpoint from "../../config/endpoints";

export const SalesTeamLeaveJson = {
  showSaveNextBtn: true,
  formPath: "/sales-team-leave-form",
  formPathForAddLeaveForSalesTeam: "/add-sales-team-leave-form",
  apiBaseURL: endpoint.leaveApply,
  changeExcel: endpoint.exportData,
  screenTitle: "Sales Team Leave",
  screenTitleForAddSalesTeamLeave: "Add Leave For Sales Team",
  showAddButton: true,
  showPdfDownload: false,
  pdfFileName: "MyClaim",
  showExcelDownload: true,
  excelFileName: "MyClaim",
  tableColumnsToFilter: [
    {
      columnDisplayName: "Employee Code",
      columnKeyName: "employeeCode",
      isChecked: true,
    },
    {
      columnDisplayName: "Sales Team Name",
      columnKeyName: "salesTeamName",
      isChecked: true,
    },
    {
      columnDisplayName: "Reporting To",
      columnKeyName: "authoritySalesPersonName",
      isChecked: true,
    },
    {
      columnDisplayName: "Leave Type",
      columnKeyName: "leaveTypeName",
      isChecked: true,
    },
    {
      columnDisplayName: "Subject",
      columnKeyName: "leaveReason",
      isChecked: true,
    },
    {
      columnDisplayName: "From Date",
      columnKeyName: "fromDate",
      isChecked: true,
    },
    {
      columnDisplayName: "To Date",
      columnKeyName: "toDate",
      isChecked: true,
    },
    {
      columnDisplayName: "No of Days",
      columnKeyName: "noOfDays",
      isChecked: true,
    },
    {
      columnDisplayName: "Status",
      columnKeyName: "statusForTable",
      isChecked: true,
    },
  ],
  fieldMeta: [
    {
      label: "Employee",
      controlType: "autocomplete",
      placeHolder: "Select Employee",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "employeeDetail",
      dataKey: "salesTeam",
      getListId: "salesTeam",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Leave Type",
      controlType: "autocomplete",
      placeHolder: "Select Leave Type",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "leaveTypeDetail",
      dataKey: "leaveType",
      getListFrom: "salesTeam",
      getListId: "leaveType",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Subject",
      controlType: "textfield",
      placeHolder: "Enter Subject",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "subject",
      isMandatory: true,
    },
    {
      label: "Leave Duration",
      controlType: "radiogroup",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "leaveFor",
      tableDataKey: "leaveFor",
      defaultValue: "0",
      radioGroupItems: [
        {
          label: "Full Day",
          value: "0",
        },
        {
          label: "First Half",
          value: "1",
        },
        {
          label: "Second Half",
          value: "2",
        },
      ],
      isMandatory: true,
    },
    {
      label: "Start Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "fromDate",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "toDate-le",
    },
    {
      label: "End Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "toDate",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "fromDate-ge",
    },

    {
      label: "Description",
      controlType: "textfield",
      placeHolder: "Enter Description",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      dataKey: "description",
      isMandatory: true,
    },
  ],
  searchList: [
    {
      label: "Month",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "month",
      isMandatory: true,
      format: "MM-YYYY",
    },
  ],

  searchListForAdmin: [
    {
      label: "From Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "fromDate",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "toDate-le",
    },
    {
      label: "To Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "toDate",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "fromDate-ge",
    },
  ],


  fieldMetaForAddSalesTeamLeave: [
    {
      label: "Leave Type",
      controlType: "autocomplete",
      placeHolder: "Select Leave Type",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "leaveTypeDetail",
      dataKey: "leaveType",
      getListId: "leaveType",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "From Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "fromDate",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "toDate-le",
    },
    {
      label: "To Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "toDate",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "fromDate-ge",
    },
    {
      label: "Leave Duration",
      controlType: "radiogroup",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "leaveFor",
      tableDataKey: "leaveFor",
      defaultValue: "0",
      radioGroupItems: [
        {
          label: "Full Day",
          value: "0",
        },
        {
          label: "First Half",
          value: "1",
        },
        {
          label: "Second Half",
          value: "2",
        },
      ],
      isMandatory: true,
    },

    {
      label: "Number Of Days",
      controlType: "textfield",
      placeHolder: "Enter Subject",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "noOfDays",
      isMandatory: true,
      disableTrue: true,
    },

    {
      label: "Subject",
      controlType: "textfield",
      placeHolder: "Enter Subject",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "subject",
      isMandatory: true,
    },

    {
      label: "Remark",
      controlType: "textfield",
      placeHolder: "Enter Remark",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      dataKey: "description",
      isMandatory: true,
    },
  ],

  searchListForSalesTeamLeave: [
    {
      label: "From Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "fromDate",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "toDate-le",
    },
    {
      label: "To Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "toDate",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "fromDate-ge",
    },
  ],
};